import { useConfig } from 'config/use-config';
import Script from 'next/script';

/** Google Tag Manager script, proxied through Taggrs.io; tags respect the per-region Consent Mode v2 default set in _document.tsx. */
const TagManagerScript: React.FC = () => {
  const { gtmScriptUrl } = useConfig();

  if (!gtmScriptUrl) {
    return null;
  }

  return (
    <Script
      id="gtm-script"
      strategy="afterInteractive"
      data-cookieconsent="ignore"
      dangerouslySetInnerHTML={{
        __html: `
          (function (w, d, s, l, i) {
              w[l] = w[l] || [];
              w[l].push({
                  'gtm.start': new Date().getTime(),
                  event: 'gtm.js'
              });

              var f = d.getElementsByTagName(s)[0],
                  j = d.createElement(s);

              j.async = true;
              j.src = i;
              f.parentNode.insertBefore(j, f);
          })(window, document, 'script', 'dataLayer', '${gtmScriptUrl}');
        `,
      }}
    />
  );
};

export default TagManagerScript;
